(function (angular) {
    'use strict';
    angular
        .module('enervee.fastTrack')
        .controller('fastTrackProductsModalCtrl', fastTrackProductsModalCtrl);

    /*
     Creates a new controller for the rebate Fast Track form Products modal
     */
    fastTrackProductsModalCtrl.$inject = [
        '$log',
        '$q',
        '$sce',
        '$state',
        '$timeout',
        '$uibModalInstance',
        'AnalyticsService',
        'CategoriesService',
        'CmsContentService',
        'EnerveeRebateService',
        'FastTrackModalService',
        'FastTrackProductsModalService',
        'ProductService',
        'SwiftypeService',
        'UtilService',
    ];
    function fastTrackProductsModalCtrl (
        $log,
        $q,
        $sce,
        $state,
        $timeout,
        $uibModalInstance,
        AnalyticsService,
        CategoriesService,
        CmsContentService,
        EnerveeRebateService,
        FastTrackModalService,
        FastTrackProductsModalService,
        ProductService,
        SwiftypeService,
        UtilService
    ) {
        var vm = this;
        vm.productsToClaim = FastTrackProductsModalService.retrieveProducts();
        vm.addProductClaim = FastTrackProductsModalService.addProduct;
        vm.removeProductClaim = removeProductClaim;
        vm.eligibleCategories = [];
        vm.selectedCategoryID = null;
        vm.serverErrors = {};
        vm.showLoader = false;
        vm.submittingProducts = false;
        vm.tangoEnabled = UtilService.isFeatureEnabled('tango_rewards');
        vm.selectingProduct = false;

        CmsContentService.retrieveCMSValue(vm, 'loadingProductText', 'fast_track:loading_products');

        /**
         * Populates the category dropdown with only categories that have rebate eligible products.
         */
        var populateEligibleCategories = function () {
            var excludedCategoryCodes = UtilService.getSiteSetting('fasttrack_excluded_category_codes', []);

            CategoriesService.getCategories().then(function (categories) {
                categories.forEach(function (category) {
                    if ((category.is_rebatable || category.is_extra_incentive_offered) &&
                        (excludedCategoryCodes.indexOf(category.category_code) === -1)) {

                        vm.eligibleCategories.push(category);
                    }
                });
            });
        };

        populateEligibleCategories();

        /**
         * Performs search to populate the product drop down selector. We only show results
         * that are eligible for rebates by passing a true flag as a third param to
         * SwiftypeService.performAutocompleteSearch(). We set claim.isProductSelected to false here so
         * that the product drop down selector can ng-show. The claim object is whichever
         * claim the user is creating.
         * @param {Object} claim - a claim object in the list of rebates being claimed
         * @param {string} claim.model_number - the current search text in the input
         * @param {number} claim.categoryName - the category chosen to search in
         * @param {Array} claim.modelList - the list of products that match the search text
         * @param {Boolean} claim.isProductSelected - whether or not the user has chosen a product to submit a rebate claim for
         * @param {number} index - the index of the claim object in the list of rebates being worked on
         */
        vm.search = function (claim, index) {
            vm.showLoader = true;
            claim.isProductSelected = false;
            claim.loadingProducts = true;
            vm.selectingProduct = true;

            SwiftypeService.performAutocompleteSearch(claim.modelNumber, {
                cancellerPromise: null,
                eligibleForRebatesOnly: true,
                applyFasttrackFilters: true,
                documentTypes: [claim.categoryName],
            }).then(function success(records) {
                claim.modelList = records[claim.categoryName];
                // $log.error(vm.modelList);
                vm.showLoader = false;
                claim.loadingProducts = false;
                if (claim.modelList.length === 0) {
                    vm.setModelNumberRequiredValidator(index);
                } else {
                    vm.removeBackendValidity('model_number_' + index, 'noproduct');
                }
            }, function error(response) {
                $log.warn("Unsuccessful autocomplete api call");
                $log.warn(response.data.message);
            });
        };

        /**
         * Removes a product from the in-progress claim.
         * Also sets the `selectingProduct` boolean to false since the in-progress product
         * selection was removed.
         *
         * @param {Number} index
         */
        function removeProductClaim(index) {
            FastTrackProductsModalService.removeProduct(index);
            vm.selectingProduct = false;
            AnalyticsService.reportEvent('Fast Track Product Removed', {});
        }

        /**
         * We want to debounce the search for models so it doesn't feel so jarring.
         * @param claim
         * @param index
         */
        vm.debounceSearch = function (claim, index) {
            UtilService.debounce('autocompleteSearch', function () {
                vm.removeBackendValidity('model_number_' + index);
                vm.search(claim, index);
            }, 500);
        };

        /**
         * Method to assign selected product to claimObject.selectedProduct and also set claimObject.isProductSelected to true
         * so that the drop down menu can hide as soon as the user clicks on a product.
         * @param {Object} product - a product object
         * @param {string} product.brand - the product's brand
         * @param {string} product.model_number - the product's `model_number`
         * @param {Object} claimObject - a claim object in the list of rebates being claimed
         * @param {number} index - the index of the claim object in the list of rebates being worked on
         */

        vm.selectProduct = function (product, claimObject, index) {
            claimObject.modelNumber = product.brand + ' ' + product.model_number;
            claimObject.selectedProduct = product;
            claimObject.isProductSelected = true;
            vm.selectingProduct = false;
            vm.removeBackendValidity('model_number_' + index, 'noproduct');
            AnalyticsService.reportEvent('Fast Track Product Added', {});
        };

        /**
         * Method to validate if a valid model number was selected
         */
        vm.validateProduct = function (product, index) {
            UtilService.debounce('validateFastTrackProduct', function () {
                if (product.isProductSelected || product.loadingProducts) {
                    vm.removeBackendValidity('model_number_' + index, 'noproduct');
                } else {
                    vm.setModelNumberRequiredValidator(index);
                }
            });
        };

        /**
         * Returns whether or not the autocomplete dropdown for this input should be shown
         *
         * @param {Object} product
         * @param {Array} product.modelList
         * @param {Boolean} product.isProductSelected
         * @return {Boolean}
         */
        vm.shouldShowAutocompleteDropdown = function (product) {
            return product.modelList && product.modelList.length > 0 && !product.isProductSelected;
        };

        /**
         * Returns whether or not the autocomplete dropdown _backdrop_ for this input should be
         * shown
         *
         * @param {Object} product
         * @param {Array} product.modelList
         * @param {Boolean} product.isProductSelected
         * @return {Boolean}
         */
        vm.shouldShowAutocompleteBackdrop = function (product) {
            return vm.shouldShowAutocompleteDropdown(product) || product.loadingProducts;
        };

        /**
         * Method used to update vm.cmsData to build the form with
         * category specific custom errors from the CMS.
         * This method is invoked when the user selects a category in the
         * category drop down selector.
         * @param {Object} claim - a claim object in the list of rebates being claimed
         * @param {Boolean} claim.isCategorySelected - whether or not the user has chosen a category to search for products
         * @param {number} claim.categoryName - the category chosen to search in
         */
        vm.selectCategory = function (claim, index) {
            claim.isCategorySelected = true;
            claim.modelNumber = '';
            claim.modelList = [];
            resetModelNumberField(index);
        };

        /**
         * Mark model as required. Made as it's own method to be used in a few places
         *
         * @param {number} index - the index of the claim object in the list of rebates being worked on
         */
        vm.setModelNumberRequiredValidator = function (index) {
            if (vm.claimForm['model_number_' + index]) {
                vm.claimForm['model_number_' + index].$setValidity('noproduct', false);
                vm.claimForm['model_number_' + index].$setTouched();
            }
        };

        /**
         * Resets the model number field for the specified index.
         *
         * @param {number} index - the index of the claim object in the list of rebates being worked on
         */
        function resetModelNumberField(index) {
            if (vm.claimForm['model_number_' + index]) {
                vm.claimForm['model_number_' + index].$setUntouched();
                vm.claimForm['model_number_' + index].$setPristine();
            }
        }

        /**
         * If a field has a backend error and we don't manually set the field to valid after it's been updated,
         * the form can't be submitted again.
         * @param {String} fieldName
         */
        vm.removeBackendValidity = function (fieldName, validatorName) {
            if (vm.claimForm !== undefined){
                vm.claimForm[fieldName].$setValidity(validatorName, true);
            }
         };

        vm.dismissModal = function (reason) {
            $uibModalInstance.dismiss(reason || 'cancel');
            AnalyticsService.reportEvent('Fast Track Product Selection Closed', {});
        };

        /**
         * Attempts to submit the claim form.
         * Any errors picked up on the backend will be displayed appropriately.
         */
        vm.submitProducts = function () {
            if (vm.selectingProduct) {
                return;
            }
            vm.submittingProducts = true;
            FastTrackProductsModalService.submitProducts().then(function (response) {
                // successful application for claim creation,
                // let's go to validation
                $uibModalInstance.close(response);
            }).finally(function () {
                vm.submittingProducts = false;
            });
        };
    }

})(angular);
